import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentDriversLicenseMeta extends BaseEntityModel {
  parentId?: number;
  lastThreeDigits?: string;
  driversLicenseNumber?: string;

  constructor(model: Partial<DocumentDriversLicenseMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.lastThreeDigits = model.lastThreeDigits;
    this.driversLicenseNumber = model.driversLicenseNumber;
  }
}
